import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";
import brandIcon from "@/assets/brand-icon.png";
import logoFull from "@/assets/native-plant-garden-planner-logo.png";

const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border/40">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center mb-4">
              <img
                src={logoFull}
                alt={BRAND.APP_NAME}
                width={73}
                height={24}
                className="h-6 w-auto object-contain opacity-80"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const fallback = target.nextElementSibling as HTMLElement;
                  if (fallback) fallback.style.display = 'flex';
                }}
              />
              <span className="items-center gap-2" style={{ display: 'none' }}>
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10 overflow-hidden">
                  <img src={brandIcon} alt="" className="h-6 w-6 object-contain" />
                </div>
                <span className="font-display text-lg font-semibold">{BRAND.APP_NAME}</span>
              </span>
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs">
              Native Plant Garden Planner helps homeowners design pollinator-friendly gardens using native plants.
            </p>
          </div>

          {/* Product */}
          <div>
            <div className="font-display font-semibold mb-4" role="heading" aria-level={2}>Product</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">How It Works</Link></li>
              <li><Link to="/what-you-get" className="text-muted-foreground hover:text-foreground transition-colors">What You Get</Link></li>
              <li><Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors">Pricing</Link></li>
              <li><Link to="/examples" className="text-muted-foreground hover:text-foreground transition-colors">Examples</Link></li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <div className="font-display font-semibold mb-4" role="heading" aria-level={2}>Community</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/plant-map" className="text-muted-foreground hover:text-foreground transition-colors">Plant Map</Link></li>
              <li><Link to="/garden-gallery" className="text-muted-foreground hover:text-foreground transition-colors">Garden Gallery</Link></li>
              <li><Link to="/gallery" className="text-muted-foreground hover:text-foreground transition-colors">Community Gallery</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <div className="font-display font-semibold mb-4" role="heading" aria-level={2}>Support</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="text-muted-foreground hover:text-foreground transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <div className="font-display font-semibold mb-4" role="heading" aria-level={2}>Legal</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/refunds" className="text-muted-foreground hover:text-foreground transition-colors">Refund & Cancellation</Link></li>
              <li><Link to="/disclaimer" className="text-muted-foreground hover:text-foreground transition-colors">Garden Plan Disclaimer</Link></li>
              <li><Link to="/image-credits" className="text-muted-foreground hover:text-foreground transition-colors">Image Credits</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-border/40 space-y-3">
          <p className="text-xs text-muted-foreground text-center max-w-2xl mx-auto leading-relaxed">
            {BRAND.DISCLAIMER}{" "}
            <Link to="/terms" className="underline underline-offset-2 hover:text-foreground transition-colors">
              Terms of Service
            </Link>
          </p>
          <p className="text-xs text-muted-foreground text-center">
            {BRAND.COPYRIGHT}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
